import React from "react";

import {
  Drawer,
  // DrawerClose,
  DrawerContent,
  // DrawerDescription,
  // DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  //   DrawerTrigger,
  DrawerClose,
} from "./index";
import { useTranslation } from "react-i18next";
import images from "../../../images";
import termsOfUseData from "./../../../contanst/termsOfUseData.json";

const TermsOfUseModal = ({ isOpen, onOpenChange, onAgree, onClose }) => {
  const { t } = useTranslation();

  // const renderWithBold = (text) => {
  //   const parts = text.split(/(\*\*[^*]+\*\*)|(\n)/g);

  //   return parts.map((part, idx) => {
  //     if (!part) return null;
  //     if (part === "\n") return <br key={idx} />;
  //     if (part.startsWith("**") && part.endsWith("**")) {
  //       return <strong key={idx}>{part.slice(2, -2)}</strong>;
  //     }
  //     return <span key={idx}>{part}</span>;
  //   });
  // };

  return (
    <>
      <Drawer open={isOpen} onOpenChange={onOpenChange}>
        {/* <DrawerTrigger className="underline block">
          <span>{t("signUp.termsOfUse")}</span>
        </DrawerTrigger> */}
        <DrawerContent className="fixed inset-0 z-50 bg-white  flex flex-col p-4 max-h-screen">
          <DrawerHeader>
            <DrawerTitle className="flex justify-start mt-6">
              <span className="text-2xl font-bold text-[#333333]">
                {t("signUp.termsOfUse")}
              </span>
            </DrawerTitle>
            {/* <DrawerDescription>{t("policy.description")}</DrawerDescription> */}
            <DrawerClose className="absolute top-[40px] right-4">
              {/* <button
                className="text-2xl w-6 h-6 font-bold text-gray-700 hover:text-gray-900"
                aria-label="Close"
              >
                &times;
              </button> */}
              <img src={images.CloseModalIconGray} className="w-6 h-6" alt="" />
            </DrawerClose>
          </DrawerHeader>
          <div className="flex-1 px-4 py-1 overflow-y-auto">
            {/* {[...Array(10)].map((_, i) => {
              const key = (i + 1).toString();
              return (
                <div key={key} className="mb-4">
                  <h4 className="font-bold mb-1">
                    {`${key}. ${t(`policy.sections.${key}.title`)}`}
                  </h4>
                  <p className="whitespace-pre-wrap text-sm text-gray-700">
                    {renderWithBold(t(`policy.sections.${key}.content`))}
                  </p>
                </div>
              );
            })} */}
            <div>
              <h3 className={"text-[#333333] text-lg font-bold"}>
                1.Introduction
              </h3>
              <div className="pl-[13px]">
                <span>
                  Welcome to Rally, the customer intelligence platform that
                  rewards you for sharing your dining experiences. These Terms
                  of Use ("Terms") govern your use of the Rally mobile
                  application ("App") and related services ("Services") provided
                  by Rally AI Pte Ltd ("Rally," "we," "us," or "our")
                </span>

                <h6 className="mt-4 text-black font-semibold">
                  By downloading, accessing, or using the Rally App, you agree
                  to be bound by these Terms. If you do not agree to these
                  Terms, please do not use our App or Services.
                </h6>
                <h3 className={"text-[#333333] text-lg font-bold mt-4"}>
                  Company Information
                </h3>

                <ul className="list-disc pl-5">
                  <li>Company Name: Rally AI Pte Ltd</li>
                  <li>
                    Registration: Singapore Company (Registered 22 January 2025)
                  </li>
                  <li>
                    Contact Email:{" "}
                    <a
                      className=" underline decoration-offset-0 decoration-[0px]"
                      href="mailto:hello@letsrally.ai"
                    >
                      hello@letsrally.ai
                    </a>
                  </li>
                  <li>Contact Phone: +65 8362 9230</li>
                </ul>
              </div>
            </div>
            <div>
              <h3 className={"text-[#333333] text-lg font-bold"}>
                2.Service Description
              </h3>
              <div className="pl-[13px]">
                <span>
                  Rally connects food and beverage businesses with consumers
                  through an engaging quest-based platform. As a user, you can:
                </span>
                <ul className="list-disc pl-5">
                  <li>
                    Complete various "quests" including surveys, photo
                    submissions, check-ins, and social sharing activities
                  </li>
                  <li>Earn Rally Tokens, XP points, and achievement badges</li>
                  <li>Convert tokens to cash rewards</li>
                  <li>Progress through 10 levels of gamified experiences</li>
                  <li>
                    Participate in co-creation, mystery shopping, and social
                    advocacy activities
                  </li>
                  <h3 className={"text-[#333333] text-lg font-bold mt-4"}>
                    Quest types
                  </h3>
                  <span>
                    Our platform currently offers Foundation Quests with
                    additional categories planned for future release:
                  </span>
                  <ul className="list-disc pl-5">
                    <li>
                      <strong>Foundation Quests:</strong> Customer segmentation,
                      journey mapping, and snap surveys
                    </li>
                    <li>
                      <strong>Co-Creation Quests:</strong> Menu innovation,
                      design contests, recipe creation
                    </li>
                    <li>
                      <strong>Social Advocacy Quests:</strong> Photo campaigns,
                      referral programs, review initiatives
                    </li>
                    <li>
                      <strong>Mystery Experience Quests:</strong> Secret
                      shopping, service audits, timing challenges
                    </li>
                    <li>
                      <strong>Market Intelligence Quests:</strong> Trend
                      validation, competitive analysis, preference testing
                    </li>
                  </ul>
                </ul>
              </div>
            </div>

            <div className="space-y-6">
              {termsOfUseData.map((section, sectionIndex) => (
                <div key={sectionIndex}>
                  <div className="flex flex-row">
                    <h3 className={"text-[#333333] text-lg font-bold"}>
                      {sectionIndex + 3}.
                    </h3>
                    <h3 className={"text-[#333333] text-lg font-bold"}>
                      {section.section}
                    </h3>
                  </div>

                  {section.subsections.map((sub, subIndex) => (
                    <div key={subIndex} className="mb-4 pl-[13px]">
                      <h3 className="font-semibold text-lg mb-2">
                        {sub.title}
                      </h3>
                      <span>{sub.subItems}</span>
                      <ul className="list-disc pl-5 space-y-1">
                        {sub.items.map((item, itemIndex) => (
                          <li key={itemIndex}>{item}</li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              ))}
            </div>

            <div>
              <h3 className={"text-[#333333] text-lg font-bold"}>
                14. Contact Information
              </h3>
              <div className="pl-[13px]">
                <span>
                  If you have questions about these Terms or need support:
                </span>

                <h3 className={"text-[#333333] text-lg font-bold mt-4"}>
                  Rally AI Pte Ltd
                </h3>

                <ul className="list-disc pl-5">
                  <li>
                    {" "}
                    <strong>Email:</strong> hello@letsrally.ai
                  </li>
                  <li>
                    {" "}
                    <strong>Phone:</strong> +65 8362 9230
                  </li>
                  <li>
                    {" "}
                    <strong>Business Hours:</strong> Monday-Friday, 10:00 AM -
                    6:00 PM SGT
                  </li>
                </ul>

                <span>
                  For urgent account issues or technical support, please contact
                  us through the in-app support feature.
                </span>
              </div>
            </div>
            <hr />
            <h6 className="mt-4 text-black font-semibold">
              By using the Rally App, you acknowledge that you have read,
              understood, and agree to be bound by these Terms of Use.
            </h6>
            {/* <Button
              className="px-4 py-3 text-base font-medium text-white bg-[#253FF6] rounded-xl w-full"
              text={t("policy.agree")}
              onClick={() => {
                onAgree();
                onClose();
              }}
            />
            <button
              className="px-4 py-3 text-base font-medium text-[#253FF6] bg-white border border-[#253FF6] rounded-xl w-full"
              onClick={onClose}
            >
              {t("policy.cancel")}
            </button> */}
          </div>

          {/* <DrawerFooter className="p-4 border-t border-gray-200">
            <Button
              className="px-4 py-3 text-base font-medium text-white bg-[#253FF6] rounded-xl w-full"
              text={t("policy.agree")}
              onClick={() => {
                onAgree();
                onClose();
              }}
            />
            <button
              className="px-4 py-3 text-base font-medium text-[#253FF6] bg-white border border-[#253FF6] rounded-xl w-full"
              onClick={onClose}
            >
              {t("policy.cancel")}
            </button>
          </DrawerFooter> */}
        </DrawerContent>
      </Drawer>
    </>
  );
};
export default TermsOfUseModal;
